var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiciAparcamientos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "68A94945-0441-4E81-B8A0-BB97EF7A9842") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.6%",
    y: "-5.6%",
    width: "107.2%",
    height: "111.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.484771 0 0 0 0 0.459066 0 0 0 0 0.437033 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Primera-fase",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NOU_Seleccionar_Pin_Mapa_bicing",
    transform: "translate(-61.000000, -709.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy",
    filter: "url(#filter-1)",
    transform: "translate(20.000000, 578.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(17.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "estacions",
    transform: "translate(24.000000, 0.000000)",
    filter: "url(#filter-2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5,0.678082192 C25.2246575,0.678082192 32.3219178,7.77534247 32.3219178,16.5 C32.3219178,25.2246575 25.2246575,32.3219178 16.5,32.3219178 C7.77534247,32.3219178 0.678082192,25.2246575 0.678082192,16.5 C0.678082192,7.77534247 7.77534247,0.678082192 16.5,0.678082192 M16.5,0 C7.39109589,0 0,7.39109589 0,16.5 C0,25.6089041 7.39109589,33 16.5,33 C25.6089041,33 33,25.6089041 33,16.5 C33,7.39109589 25.6089041,0 16.5,0 L16.5,0 Z",
    id: "Shape",
    fill: "#E2001D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.442466, 8.114384)",
    stroke: "#E2001D",
    strokeWidth: 0.589285714
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1150685,16.7712329 L0,16.7712329 L0,16.409589 C0,15.6636986 0.610273973,15.0534247 1.35616438,15.0534247 L10.7815068,15.0534247 C11.5273973,15.0534247 12.1376712,15.6636986 12.1376712,16.409589 L12.1376712,16.7712329 L12.1150685,16.7712329 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22739726,0.406849315 C8.22739726,0.180821918 8.0239726,0 7.79794521,0 L4.36232877,0 C4.13630137,0 3.93287671,0.180821918 3.93287671,0.406849315 L3.20958904,15.0534247 L8.88287671,15.0534247 L8.22739726,0.406849315 Z M6.73561644,13.2678082 C6.73561644,13.6294521 6.44178082,13.9458904 6.05753425,13.9458904 C5.67328767,13.9458904 5.37945205,13.6520548 5.37945205,13.2678082 L5.37945205,2.21506849 C5.37945205,1.85342466 5.67328767,1.5369863 6.05753425,1.5369863 C6.44178082,1.5369863 6.73561644,1.83082192 6.73561644,2.21506849 L6.73561644,13.2678082 Z",
    id: "Shape"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiciAparcamientos);
export default __webpack_public_path__ + "static/media/bici-aparcamientos.35fa6f6b.svg";
export { ForwardRef as ReactComponent };